module.exports = __webpack_public_path__ + "img/8.84fe18fb.png";